module.exports = __webpack_public_path__ + "img/loyalty-mockup-1.5ab9eaca.png";